/**
 * Shared Metrics Utilities
 *
 * Single source of truth for standard KPI calculations
 * used across Appointment Results, Command Dashboard,
 * Disposition Report, Rep Scorecards, and Commission Engine.
 */

import type { AppointmentResult } from "@/data/appointmentResultTypes";

/**
 * Standard close rate: sold / demos ran.
 * "Demos ran" = total appointments minus no-demos.
 * Returns a ratio between 0 and 1 (e.g. 0.35 = 35%).
 */
export function calculateCloseRate(results: AppointmentResult[]): number {
  const sold = results.filter(r => r.resultType === "sold").length;
  const noDemo = results.filter(r => r.resultType === "no_demo").length;
  const demosRan = results.length - noDemo;
  return demosRan > 0 ? sold / demosRan : 0;
}

/**
 * Convenience: returns close rate as a rounded integer percentage.
 */
export function calculateCloseRatePercent(results: AppointmentResult[]): number {
  return Math.round(calculateCloseRate(results) * 100);
}
